/**
 * 首页翻译模块 - 中文
 *
 * SEO 关键词覆盖：
 * - 远红外取暖器 / 辐射加热器
 * - 节能红外取暖器
 * - 户外露台取暖器 / 餐厅 / 车间
 * - 批发 / OEM / 厂家
 */

import type { HomeTranslations } from '../../types';

export const zhHome: HomeTranslations = {
  hero: {
    future: '取暖的未来',
    title: '高效节能',
    subtitle: '红外取暖',
    description: '将阳光般的温暖带到户外空间。我们先进的远红外技术为餐厅露台、花园、车间和泳池旁区域提供即时、安静、节能的辐射热量。',
    cta: '探索产品',
    watchVideo: '观看视频',
    trusted: '全球5000+客户的信赖',
    worldwide: '全球分销网络',
    slides: {
      "slide5": {
        "title": "广交会",
        "subtitle": "广州见，暖意相约",
        "description": "欢迎莅临晶辉展位，现场了解我们的取暖产品，共话合作机会。",
        "exhibition": {
          "eyebrow": "JH HEATSUP · 广交会预告",
          "date": "2026年10月15–19日",
          "venue": "广州 · 中国进出口商品交易会展馆",
          "boothLabel": "欢迎莅临展位",
          "booth": "3.2号馆L16摊位"
        }
      },
      "slide4": {
        "title": "环球资源香港",
        "subtitle": "消费电子展",
        "description": "欢迎莅临晶辉展位，与我们交流取暖产品及合作机会。",
        "exhibition": {
          "eyebrow": "JH HEATSUP · 香港展会预告",
          "date": "2026年10月11–14日",
          "venue": "香港 · 亚洲国际博览馆",
          "boothLabel": "欢迎莅临展位"
        }
      },
      slide1: {
        title: '高效节能',
        subtitle: '红外取暖',
        description: '将阳光般的温暖带到户外空间。我们先进的远红外技术为餐厅露台、花园、车间和泳池旁区域提供即时、安静、节能的辐射热量。',
      },
      slide2: {
        title: '安全可靠',
        subtitle: '适合日常使用',
        description: '采用IPX4防水等级、过热保护和耐用材质设计，我们的远红外取暖器可日复一日提供稳定可靠的温暖——整夜运行也安全无忧。',
      },
      slide3: {
        title: '超静音',
        subtitle: '舒适温暖',
        description: '享受无光、无声、不干燥的舒适辐射暖意，不会循环粉尘。适合家庭和办公室使用的健康远红外取暖体验。',
      },
    },
  },
  about: {
    title: '关于晶辉取暖器',
    subtitle: '自2006年起引领远红外技术',
    intro1: '福建晶辉环境科技有限公司（JH Heatsup）是中国领先的远红外取暖器制造商，专注于家用和商用节能远红外辐射取暖器的研发与生产。',
    intro2: '我们专注于研发、OEM/ODM制造和全球分销，为世界各地的批发客户提供高品质远红外取暖器。产品已获得CE、CB、SAA及RoHS认证，出口至欧洲、澳大利亚、中东和东南亚等80多个国家和地区。',
    stats: {
      yearsExperience: '年行业经验',
      countriesExported: '出口国家',
      patents: '专利数量',
      satisfaction: '客户满意度',
    },
    ceoQuote: '"我们致力于通过科技创造一个更绿色、更温暖的世界。"',
    ceoLabel: '- 首席执行官寄语',
    factoryAlt: '晶辉取暖器远红外取暖器工厂生产线',
  },
  features: {
    title: '为什么选择晶辉远红外取暖器',
    subtitle: '我们的远红外技术模拟太阳的自然取暖原理，直接温暖物体和人体，而不仅仅是空气。这使得远红外辐射取暖器比传统对流取暖器节能高达80%。',
    energy: {
      title: '高效节能',
      desc: '高达99%的热转换效率——远红外辐射取暖器比对流取暖器节省高达80%的电力',
    },
    quiet: {
      title: '超静音',
      desc: '无风扇远红外设计，零光线、零噪音、零粉尘循环',
    },
    safe: {
      title: '安全可靠',
      desc: 'IPX4防水远红外取暖器，内置过热保护，室内外均可安全使用',
    },
    smart: {
      title: '智能控制',
      desc: 'WiFi涂鸦APP远程温度控制——用手机即可节能省电',
    },
  },
  categoriesSection: {
    title: '按类别选购',
    subtitle: "探索红外、便携式和燃气取暖器，为您的空间找到合适的取暖方案——从户外露台到室内客厅。",
    viewAll: '查看全部产品',
    cards: {
      infrared: {
        badge: '热门',
        tagline: '远红外辐射取暖器，高效精准供暖',
        description: '适用于户外露台、餐厅露台、车间、仓库及壁挂式室内取暖等场景。',
        cta: '立即选购',
      },
      portable: {
        tagline: '便携式碳纤维和卤素取暖器，灵活取暖',
        description: '适合家庭、办公室、桌下取暖及户外娱乐区域使用。',
        cta: '立即选购',
      },
      gas: {
        tagline: "燃气露台取暖器与火炉桌，温暖户外空间",
        description: "适用于餐厅露台、花园及庭院聚会，打造舒适温暖的户外休闲空间。",
        cta: "立即选购",
      },
    },
  },
  ctaSection: {
    title: '准备好升级您的取暖方式？',
    subtitle: '立即联系晶辉取暖器，获取批发报价、OEM/ODM服务和免费咨询。',
    cta: '获取报价',
  },
};
